import { SimpleReactComponentProps } from '../../../types/components';

export interface TitleProps extends SimpleReactComponentProps {
	title: string;
	style: string;
}

const h1ClassName = 'text-3xl font-bold';
const h2ClassName = 'text-2xl font-bold';
const h3ClassName = 'text-lg font-bold';
const h4ClassName = 'text-base font-bold';

export const Title = ({ title, style, classOverrides }: TitleProps) => {
	switch (style) {
		case 'H2':
			return <h2 className={classOverrides || h2ClassName}>{title}</h2>;
		case 'H3':
			return <h3 className={classOverrides || h3ClassName}>{title}</h3>;
		case 'H4':
			return <h4 className={classOverrides || h4ClassName}>{title}</h4>;
		default:
			return <h1 className={classOverrides || h1ClassName}>{title}</h1>;
	}
};
